import { Card, CardContent } from '@/components/ui/card';
import { SectionHeading, EmptySection } from './shared';

interface Props {
  data: any | null;
}

export default function NarrativeSection({ data }: Props) {
  return (
    <section>
      <SectionHeading id="section-narrative" title="Shift Narrative" />
      {!data?.content ? (
        <EmptySection name="shift narrative" />
      ) : (
        <Card className="mt-2">
          <CardContent className="pt-4">
            <p className="whitespace-pre-wrap text-sm leading-relaxed">{data.content}</p>
          </CardContent>
        </Card>
      )}
    </section>
  );
}
